module.exports = __webpack_public_path__ + "img/8.64d9a6d8.png";